<template>
  <div class="template-data-page"
       v-loading="page.loading"
       element-loading-text="页面加载中，请稍等...">
    <div class="data-page-content">
      <div class="data-page-pane" :class="{'layout-scroll': isWrapScroll}" v-if="page.data.pageUrl">
        <iframe frameborder="0" scrolling="auto" :src="page.data.pageUrl"></iframe>
      </div>
      <template v-else>
        <Hint class="page-load-failed" :icon="false" v-if="!page.loading">
          <span>页面加载失败</span>
          <div class="button-group">
            <el-button type="primary" size="mini" plain @click="loadInitPageData">点击重试</el-button>
          </div>
        </Hint>
      </template>
    </div>
  </div>
</template>

<script>
import baseApiUrl from '../../constants/baseApiUrl'
import routeConfig from '../../constants/routeConfig'
import deviceUtils from '../../util/deviceUtils'
import Hint from '../elements/Hint'
export default {
  name: 'TemplateDataPage',
  components: {Hint},
  data () {
    return {
      page: {
        loading: false,
        loaded: false,
        data: {
          pageUrl: null
        }
      }
    }
  },
  computed: {
    isWrapScroll: function () {
      return deviceUtils.isIOSDevice()
    }
  },
  methods: {
    loadInitPageData: function () {
      let postParams = this.$extend(this.$attrs)
      if (!postParams[routeConfig.DataPage.param]) {
        return
      }
      this.page.loading = true
      this.$ajax({
        url: baseApiUrl.DataPageUrl,
        method: 'post',
        data: this.$qs.stringify(postParams, {
          arrayFormat: 'repeat'
        })
      }).then((response) => {
        this.page.data.pageUrl = response.data['pageUrl'] || '/'
      }).finally(() => {
        this.page.loading = false
        this.page.loaded = true
      })
    }
  },
  mounted () {
    this.loadInitPageData()
  },
  activated () {
    if (this.page.loaded) {
      if (!this.page.data.pageUrl) {
        this.loadInitPageData()
      }
    }
  }
}
</script>

<style lang="scss">
  .template-data-page {
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    & > .data-page-content {
      position: relative;
      height: 100%;
      background-color: #fff;
      & > .data-page-pane {
        position: relative;
        height: 100%;
        & > iframe {
          width: 100%;
          height: 100%;
        }
      }
      .page-load-failed {
        .button-group {
          margin: 10px auto;
          text-align: center;
          .el-button {
            padding: 5px 12px;
            border-radius: 0;
          }
        }
      }
    }
  }
</style>
